import React from "react";

import {
    Row,
    Col,
    Form,
    InputGroup,
} from "react-bootstrap-v5";

import { Formik } from 'formik';
import * as yup from 'yup';

import Utils from "../../../utils/utils";
import { ActiveInactive } from "../../../utils/enums";
import { BillingTypes } from "../../../utils/enums";

import RSuiteSelectPicker from '../../../components/OLD/Select/RSuiteSelectPicker';
import makeCRUD from "../../../components/dropdown/smartInputDropdown/makeCRUD";
import InputLayout from "../../../components/input/InputLayout";
import SmartInputDropdown from '../../../components/dropdown/smartInputDropdown/SmartInputDropdown';

import { connect } from 'react-redux'
import { clear } from "../../../../setup/redux/actions";
import { dispatchApiCallGet, dispatchApiCallPost, dispatchApiCallPut, dispatchApiCallDelete } from '../../../../setup/redux/dispatch/actions'


const SmartDropdown = makeCRUD(SmartInputDropdown);


const formFields = {
    billingType: {
        id: 'billingType',
        label: 'Billing Type',
        placeholder: ' ',
    },
    useBinWeightQuantity: {
        id: 'useBinWeightQuantity',
        label: 'Link to Bin Weight',
        placeholder: ' ',
    },
}
const formSchema = yup.object().shape({
    isEdit: yup.bool().oneOf([true, false]),
    billingType: yup.number().nullable().label(formFields.billingType.label),
    useBinWeightQuantity: yup.bool().nullable().label(formFields.useBinWeightQuantity.label),
});


class BulkUpdateBillingCategoryForm extends React.Component {

    constructor(props) {
        super(props);

        this.pageName = 'billing_category_bulk_update';

        this.refForm = React.createRef();

        let id = (props.id) ? props.id : null;


        this.state = {
            id: id,

            initialValues: {
                isEdit: false,
                billingType: null,
                chargeCategoryId: null,
                useBinWeightQuantity: null
            },
        };
    }

    componentDidMount() {
        this.init();
    }

    componentWillReceiveProps(nextProps) {
        this.reduxProps(nextProps);
    }


    /* API */
    reduxProps = nextProps => {
    }
    /* END API */


    /* FUNCTIONS */
    setLoading = (state = false) => {
        if (this.props.onLoading) {
            this.props.onLoading(state);
        }
    }
    init = () => {
        if (this.refForm && this.refForm.current) {
            this.setLoading(true);

            this.setLoading(false);
        }
    }
    prepareData = (form) => {
        let data = {
            billingType: form.billingType,
            useBinWeightQuantity: form.useBinWeightQuantity
        };


        if (this.state.id) {
            data['ids'] = this.state.id;
        }

        return data;
    }
    setSubmit = (form) => {
        if (this.props.onSubmit) {
            this.props.onSubmit(form);
        }
    }
    /* END FUNCTIONS */


    /* FORM */
    form = (formOptions) => {
        let {
            handleChange,
            setFieldValue,
            validateForm,
            values,
            errors,
        } = formOptions;

        return <>
            <InputLayout
                label={formFields.billingType.label}
            >
                <Form.Control
                    as={SmartInputDropdown}
                    isInvalid={false}
                    errorText={''}

                    label={values.billingType}
                    options={[
                        {
                            value: BillingTypes.Invoice,
                            title: 'Invoice',
                        },
                        {
                            value: BillingTypes.Purchase,
                            title: 'Purchase',
                        },
                        {
                            value: BillingTypes.Expense,
                            title: 'Expense',
                        }
                    ]}
                    placeholder={formFields.billingType.placeholder}
                    disabled={false}
                    showDefault={false}
                    isLoading={false}
                    showSearch={false}
                    showClear={true}
                    showFooter={false}
                    isInfiniteScroll={false}

                    onChange={async (value, item, i) => {
                        await setFieldValue('billingType', value);
                    }}
                    onClear={async () => {
                        await setFieldValue('billingType', null);
                    }}
                />
            </InputLayout>

            <InputLayout
                label={formFields.useBinWeightQuantity.label}
            >
                <Form.Control
                    as={SmartInputDropdown}
                    isInvalid={false}
                    errorText={''}

                    label={values.useBinWeightQuantity}
                    options={[
                        {
                            value: false,
                            title: 'No',
                        },
                        {
                            value: true,
                            title: 'Yes',
                        }
                    ]}
                    placeholder={formFields.useBinWeightQuantity.placeholder}
                    disabled={false}
                    showDefault={false}
                    isLoading={false}
                    showSearch={false}
                    showClear={true}
                    showFooter={false}
                    isInfiniteScroll={false}

                    onChange={async (value, item, i) => {
                        await setFieldValue('useBinWeightQuantity', value);
                    }}
                    onClear={async () => {
                        await setFieldValue('useBinWeightQuantity', null);
                    }}
                />
            </InputLayout>
        </>
    }
    /* END FORM */


    render() {
        return <Formik
            innerRef={this.refForm}
            validationSchema={formSchema}
            initialValues={this.state.initialValues}
            enableReinitialize={true}
            validateOnMount={false}
            validateOnChange={false}
            onSubmit={(form, e) => {
                this.setLoading(true);
                let data = this.prepareData(form);
                this.setSubmit(data);
            }}
        >
            {(formOptions) => {
                return <Form className='w-100 p-5' noValidate autoComplete="off" onSubmit={formOptions.handleSubmit} onKeyDown={(keyEvent) => {
                    // if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
                    //     keyEvent.preventDefault();
                    // }
                }}>
                    <Row>
                        <Col xs={12} className={'ps-2 pe-2'}>{this.form(formOptions)}</Col>
                    </Row>
                </Form>
            }}
        </Formik>
    }
}

const mapDispatchToProps = {
    dispatchApiCallGet,
    dispatchApiCallPost,
    dispatchApiCallPut,
    dispatchApiCallDelete,
    clear,
}

export default connect(Utils.mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(BulkUpdateBillingCategoryForm);
